import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimCalculateInflationEnum } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimUseActKC2InflationValueGql } from '../bimWorkOrderActsKc2Queries';

interface IUseBimActKC2InflationValue {
    onSuccess: () => void;
}

const requestId = 'bimUseActKC2InflationValue';

export const useBimActKC2InflationValue = (props: IUseBimActKC2InflationValue) => {
    const dispatch = useDispatch();
    const { onSuccess } = props;

    const [bimUseActKC2InflationValueReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimUseActKC2InflationValueReset(undefined);

        onSuccess();
    }, [bimUseActKC2InflationValueReset, onSuccess]);

    const [, bimUseActKC2InflationValueStatus, , bimUseActKC2InflationValueRequest] = useRequest({
        requestId,
        query: bimUseActKC2InflationValueGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimUseActKC2InflationValueMakeRequest = useCallback(
        (actKC2Id: any, calculateInflation: BimCalculateInflationEnum) => {
            if (bimUseActKC2InflationValueStatus !== RequestStatus.FETCHING) {
                dispatch(bimUseActKC2InflationValueRequest({ actKC2Id, calculateInflation }));
            }
        },
        [bimUseActKC2InflationValueRequest, bimUseActKC2InflationValueStatus, dispatch],
    );

    const setInflationInProgress = bimUseActKC2InflationValueStatus === RequestStatus.FETCHING;

    useEffect(() => {
        bimUseActKC2InflationValueReset(undefined);
    }, [bimUseActKC2InflationValueReset]);

    return {
        bimUseActKC2InflationValueMakeRequest,
        setInflationInProgress,
    };
};
